import { useEffect } from "react";
import "./PreorderInfoModal.css";

/* ── Icons ── */

const BackArrow = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      d="M15 5 8 12l7 7"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* ── Content ── */

const FLOW_STEPS = [
  {
    title: "Ingredients arrive 3 hours before cooking",
    text: "Bought close to cooking time, based on the day's orders — nothing stored or refrigerated.",
  },
  {
    title: "Cooked just like home",
    text: "No tasting salt, no palm oil, no food colour — just sunflower oil, cooked fresh from scratch.",
  },
  {
    title: "Delivered on time",
    text: "Packed fresh and sent out right for your meal window.",
  },
];

const ANSWERS = [
  {
    q: "How are you affordable?",
    a: "We cook only what's needed and deliver in slots — so you're not paying for rider inefficiency or food waste.",
  },
  {
    q: "How do you assure freshness?",
    a: "The menu changes every session — nothing is reused.",
  },
  {
    q: "Can I get food in 30 minutes?",
    a: "We're built for freshness, not speed — no pre-made gravies lying around. Pre-order, or catch extra portions before the cutoff.",
  },
];

const PreorderInfoModal = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (!isOpen) return undefined;

    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    const previousOverflow = document.body.style.overflow;

    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="pim-overlay">
      <div className="pim-backdrop" onClick={onClose} />

      <div className="pim-page" role="dialog" aria-modal="true" aria-label="Why DailyDish?">
        <div className="pim-header">
          <button className="pim-back-btn" onClick={onClose} aria-label="Close">
            <BackArrow />
          </button>
          <div>
            <div className="pim-header-title">Why DailyDish?</div>
            <div className="pim-header-sub">Fresh, home-style, made to order</div>
          </div>
        </div>

        <div className="pim-scroll">
          <div className="pim-intro">
            <h1>It's simple, really.</h1>
            <p>
              We plan before we cook, and prepare a few extra portions too — so
              there's usually something fresh even at the last minute.
            </p>
          </div>

          <div className="pim-flow">
            {FLOW_STEPS.map((step, i) => (
              <div className="pim-flow-item" key={step.title}>
                <div className="pim-flow-num">{i + 1}</div>
                <div className="pim-flow-text">
                  <h3>{step.title}</h3>
                  <p>{step.text}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="pim-answers">
            <div className="pim-answers-label">A FEW THINGS PEOPLE ASK US</div>
            {ANSWERS.map(({ q, a }) => (
              <div className="pim-answer-row" key={q}>
                <div className="pim-check">✓</div>
                <p>
                  <b>{q}</b> {a}
                </p>
              </div>
            ))}
          </div>

          <div className="pim-cta-wrap">
            <button className="pim-cta" onClick={onClose}>
              Ok, cook it right for me
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreorderInfoModal;
